<template>
  <div style="box-sizing: border-box; padding: 10px 20px 0; min-width: 1080px">
    <div class="section-right-content-box">
      <div class="integralChange publicStyle">
        <div class="jifRecords">黑名单列表</div>
        <div class="lineTwo"></div>

        <!-- 输入框查询列表 -->
        <div>
          <el-form
            ref="formSearch"
            :inline="true"
            :model="tableForm"
            label-width="80px"
          >
            <el-form-item label="买家账号:">
              <el-input
                size="small"
                v-model="tableForm.pin"
                placeholder="请输入买家账号"
                style="margin-right: 40px"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="手机号码:">
              <el-input
                size="small"
                v-model="tableForm.mobile"
                placeholder="请输入手机号码"
                style="margin-right: 40px"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="备注:">
              <el-input
                size="small"
                v-model="tableForm.remark"
                placeholder="备注"
                style="margin-right: 40px"
              ></el-input>
            </el-form-item>
            <el-form-item label="添加时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="tableForm.orderStartTimeStart"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="tableForm.orderStartTimeEnd"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTimeSendTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <div style="text-align: center" class="btn">
              <el-button
                class="share_button1"
                v-zoom="{ from: pageName, name: '查询' }"
                @click="searchFormOne"
              >
                <i
                  class="el-icon-search"
                  style="display: inline-block; width: 14px; height: 12px"
                ></i>
                查询
              </el-button>
              <el-button
                size="small"
                class="share_button2"
                @click="resetForm"
                style="margin: 0 auto"
                >重置</el-button
              >
            </div>
          </el-form>
        </div>
      </div>

      <!-- 添加,删除,查询按钮 -->
      <div class="publicStyle bottombase">
        <div style="margin: 8px 0px 0px 0px" class=".float-right-button">
          <el-button
            class="share_button3"
            @click="addBlackList = true"
            v-zoom="{ from: pageName, name: '添加黑名单' }"
            style="width: 110px"
          >
            <img
              src="@/assets/images/member/new_establish.png"
              style="
                display: inline-block;
                float: left;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin-right: 3px;
              "
            />
            添加黑名单
          </el-button>
          <el-button
            @click="batchopen1(formDataList.bid)"
            v-zoom="{ from: pageName, name: '删除黑名单' }"
            plain
            style="margin-left: 12px"
            class="share_button2"
            >删除黑名单</el-button
          >
          <el-button
            @click="delSmsBlackListBySelectCilck1()"
            v-zoom="{ from: pageName, name: '按查询结果删除' }"
            class="share_button2"
            style="margin: 0 0px 19px 12px; width: 120px"
            >按查询结果删除</el-button
          >
          <el-button
            @click="exportData()"
            v-zoom="{ from: pageName, name: '导出' }"
            style="margin-left: 12px; float: right"
            class="share_button2"
            >导出</el-button
          >
          <el-button
            @click="
              dialogVisible = true;
              handlClear();
            "
            v-zoom="{ from: pageName, name: '导入' }"
            class="share_button1"
            style="margin-left: 12px; float: right"
            >导入</el-button
          >
        </div>

        <!-- 添加黑名单弹窗 -->
        <el-dialog
          title="添加黑名单"
          :visible.sync="addBlackList"
          :before-close="closeinsertBlackClick"
          width="700px"
        >
          <el-form :model="form">
            <!-- <el-radio
              v-model="form.radio"
              v-if="!venderType"
              label="1"
              style="margin: 0 0 20px 65px"
              >手机号</el-radio
            > -->
            <el-radio
              v-model="form.radio"
              label="2"
              style="margin: 0 0 20px 65px"
              >买家账号</el-radio
            >

            <el-input
              type="form.textarea"
              v-model="form.insertmobile"
              :rows="5"
              placeholder="输入手机号"
              style="margin: 0 50px 20px 65px; width: 80%"
              v-if="form.radio == 1 && venderType == false"
            ></el-input>
            <el-input
              type="form.textarea"
              v-model="form.insertpin"
              :rows="5"
              placeholder="输入买家账号"
              style="margin: 0 50px 20px 65px; width: 80%"
              v-else
            ></el-input>

            <div style="margin: 10px 50px 20px 65px">
              <span style="color: rgb(254, 77, 69)"
                >注：1.多个账号用","’隔开；2.超过100个建议使用批量导入；</span
              >
              <br />
              <br />
              <span>备注</span>
            </div>
            <el-input
              type="form.textarea"
              :rows="5"
              v-model="form.insertremark"
              placeholder="备注"
              style="margin: 0 50px 20px 65px; width: 80%"
            ></el-input>
          </el-form>
          <div slot="footer" class="dialog-footer" style="margin-top: -25px">
            <el-button
              class="b1"
              style="margin-left: 325px"
              @click="closeinsertBlackClick"
              >取 消</el-button
            >
            <el-button
              type="primary"
              class="b2"
              @click="
                insertBlackClick();
                addBlackList = false;
                resetForm();
              "
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <!-- 添加导入弹窗 -->

        <!-- 导入手机弹框部分:before-close="handleClose"-->
        <el-dialog
          title="导入黑名单"
          :visible.sync="dialogVisible"
          :before-close="closeimportBlacklist"
          width="570px"
        >
          <!-- 开头标签 -->
          <el-form ref="form">
            <el-form-item>
              <template>
                <el-radio v-model="mobileType" label="0" v-if="!venderType"
                  >导入手机号码</el-radio
                >
                <el-radio v-model="mobileType" label="1">导入买家账号</el-radio>
              </template>
              <div>
                <el-upload
                  :action="uploadUrl"
                  class="upload-demo"
                  ref="upload"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                  :on-error="uploadError"
                  :show-file-list="false"
                  :data="{ mobileType: mobileType }"
                  :file-list="fileList"
                >
                  <!-- <el-input
                    type="textarea"
                    rows="1"
                    style="width: 430px; float: left; min-height: 33px"
                  ></el-input> -->
                  <div class="item_select_text">{{ fileName }}</div>
                  <el-button slot="trigger" size="small" type="danger"
                    >选取文件</el-button
                  >
                  <div v-if="mobileType == '0'">
                    <span style="color: #f56c6c; float: left">
                      提示：文件不能超过50M，重复号码自动过滤！
                    </span>
                    <br />
                    <span
                      size="small"
                      type="primary"
                      @click="downloadTemplate"
                      style="
                        color: #7f85e9;
                        cursor: pointer;
                        float: right;
                        margin: -30px 10px 0 0;
                      "
                      >下载手机号模板</span
                    >
                  </div>
                  <div v-else>
                    <span style="color: #f56c6c; float: left">
                      提示：文件不能超过50M，重复账号自动过滤！
                    </span>
                    <br />
                    <span
                      size="small"
                      type="primary"
                      @click="downloadTemplate"
                      style="
                        color: #7f85e9;
                        cursor: pointer;
                        float: right;
                        margin: -30px 10px 0 0;
                      "
                      >下载买家账号模板</span
                    >
                  </div>

                  <span style="color: #f56c6c; float: left"
                    >(只支持xlsx、xls两种类型的上传文件)</span
                  >
                  <div
                    style="
                      display: inline-block;
                      width: 250px;
                      height: 33px;
                      margin-left: 5px;
                    "
                    v-if="isupload"
                    class="procontain"
                  >
                    <!-- <div class="proInfo">
                      <i
                        v-if="success === false"
                        @click="reload($event)"
                        class="el-icon-refresh"
                        style="
                          display: inline-block;
                          margin: 0 3px;
                          color: #999;
                          height: 20px;
                          line-height: 20px;
                          vertical-align: top;
                        "
                      ></i>
                      <div class="proclose" @click="closePro($event)">
                        <i style="color: #999" class="el-icon-close"></i>
                      </div>
                    </div> -->
                    <!-- <el-progress
                      :percentage="process"
                      v-if="success === ''"
                    ></el-progress> -->
                    <!--正常进度-->
                    <!-- <el-progress
                      :percentage="process"
                      status="success"
                      v-if="process === 100 && success === true"
                    ></el-progress> -->
                    <!--进度成功-->
                    <!-- <el-progress
                      :percentage="process"
                      status="exception"
                      v-if="process === 100 && success === false"
                    ></el-progress> -->
                    <!--进度失败-->
                  </div>
                </el-upload>
              </div>
            </el-form-item>
            <div class="rem">
              <el-form-item>
                <el-input
                  type="textarea"
                  v-model="remark"
                  maxlength="50"
                  rows="4"
                  class="em-input"
                  placeholder="可输入五十字以内的备注"
                ></el-input>
                <span class="quantLimit">{{ remark.length }}/50</span>
              </el-form-item>
              <el-button
                slot="trigger"
                style="margin-left: 150px"
                size="small"
                class="b1"
                @click="closeimportBlacklist"
                >取消</el-button
              >
              <el-button
                style="margin-right: 100px"
                slot="trigger"
                size="small"
                class="b2"
                @click="importBlacklist"
                >确认</el-button
              >
            </div>
          </el-form>
        </el-dialog>

        <!-- 表单部分 -->
        <el-table
          v-loading="loading"
          tooltip-effect="light"
          :data="tableData"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          style="border: 1px solid #eee"
          empty-text="暂无数据"
          @sort-change="changeTableSort"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column
            type="selection"
            width="80"
            v-model="tableData.bid"
          ></el-table-column>
          <el-table-column prop="pin" label="买家账号">
            <template slot-scope="scope">
              <div class="show-box" v-if="!scope.row.pinState">
                <span>{{ scope.row.pin }}</span>
                <!-- <div
                  class="hover-show"
                  @click="showInfo(1, scope.row, scope.$index)"
                  style="width: 110px"
                  :style="{ background: globalBG }"
                >
                  显示买家账号
                </div> -->
              </div>
              <div v-else>{{ scope.row.pin }}</div>
            </template>
            <!-- <template slot="header" slot-scope="scope">
              <span>
                买家账号
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="!allShow1"
                  @click="allShow1 = true"
                  >(显示全部)</span
                >
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="allShow1"
                  @click="allShow1 = false"
                  >(单行显示)</span
                >
              </span>
            </template> -->
          </el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号码" v-if="!venderType">
            <template slot-scope="scope">
              <div class="show-box" v-if="!scope.row.mobileState">
                <span>{{ scope.row.mobile || "--" }}</span> -->
                <!-- <div
                  class="hover-show"
                  @click="showInfo(0, scope.row, scope.$index)"
                  style="width: 110px"
                  :style="{ background: globalBG }"
                >
                  显示手机号码
                </div> -->
              <!-- </div>
              <div v-else>{{ scope.row.mobile || "--" }}</div>
            </template> -->

            <!-- <template slot="header" slot-scope="scope">
              <span>
                手机号码
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="!allShow2"
                  @click="allShow2 = true"
                  >(显示全部)</span
                >
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="allShow2"
                  @click="allShow2 = false"
                  >(单行显示)</span
                >
              </span>
            </template> -->
          <!-- </el-table-column> -->
          <el-table-column prop="crtime" label="添加时间"></el-table-column>
          <el-table-column prop="remark" label="备注">
            <template slot="header" slot-scope="scope">
              <span>
                备注
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="!allShow3"
                  @click="allShow3 = true"
                  >(展开全部)</span
                >
                <span
                  class="table-message"
                  style="cursor: pointer"
                  v-if="allShow3"
                  @click="allShow3 = false"
                  >(单行显示)</span
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div
                class="operation"
                v-zoom="{ from: pageName, name: '删除' }"
                @click="open1(scope.row.bid)"
              >
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 表格分页 -->
        <el-pagination
          style="text-align: right; margin-top: 20px"
          @size-change="handleSizeChange"
          background
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="formDataList.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          :current-page="formDataList.current"
        ></el-pagination>
      </div>
    </div>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >确定要删除吗?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible1"
      width="400px"
      :before-close="closehandleDelete1"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >确定要删除吗?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete1">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 按查询删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible2"
      width="400px"
      :before-close="closehandleDelete2"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >确定要删除吗?</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete2">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  listBlack,
  delSmsBlackList,
  exportBlack,
  delSmsBlackListBySelect,
  insertBlack,
  importBlack,
  blackDetail,
} from "@/api/smsBlackList";
import inputForm from "./inputFrom//inputForm";
import formOne from "./inputFrom/input_form";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "share_polite",
  filters: {
    statusStr(status) {
      return { 0: "未知", 1: "男", 2: "女", null: "null" }[status];
    },
  },
  components: {
    inputForm,
    formOne,
  },
  data() {
    return {
      pageName: "客户管理-黑名单",
      tableForm: {
        orderStartTimeStart: '',
        orderStartTimeEnd: '',
      },
      // 表格内容
      multipleSelection: [], // 表格多选
      allShow1: false, // 买家账号信息是否全部显示
      allShow2: false, // 手机号码信息是否全部显示
      allShow3: false, // 备注信息是否全部显示
      bothSendMsg: false, // 按查询结果发送短信 模态
      mobileType: "0",
      remark: "",
      uploadUrl: "",
      fileList: [],
      loading: true,
      isupload: false,
      selectEffectObj: {},
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.formDataList.startCreateTime) {
            return (
              time.getTime() <
              new Date(this.formDataList.startCreateTime).getTime()
            );
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.formDataList.endCreateTime) {
            return (
              time.getTime() >
              new Date(this.formDataList.endCreateTime).getTime()
            );
          } else {
          }
        },
      },

      formDataList: {
        size: 10, //页面size
        current: 1, //页码
        //  pin: "", //买家账号
        // mobile: "", //手机号码
        // remark:"",  //备注
        // bid:"",
        // crtime:"",//创建时间
        type: "",
        // crtimeStart: "",
        // crtimeEnd: "",
        // orderStartTimeStart: "", //提交时间开始
        // orderStartTimeEnd: "", //提交时间结束
      },
      addBlackList: false,
      dialogVisible: false,
      form: {
        radio: "2",
        textarea: "",
        insertpin: "", //添加买家账号
        insertmobile: "", //添加手机号码
        insertremark: "", //添加备注
      },
      tableData: [],

      searchCount: true,
      size: 0,
      totalNum: 0,
      filePath: "",
      fileName: "",
      bidid: "",
      outerVisible: false,
      outerVisible1: false,
      outerVisible2: false,
      mytimestart:"",
opentime:true,
      mytimeend:"",
    };
  },

  created() {},
  mounted() {
    this.istime();
    this.queryList();
    this.change();
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  methods: {
    //自营变化事件
    change() {
      // console.log(this.venderType);
      if (this.venderType == true) {
        this.form.radio = "2";
      }
    },

    istime(){
      this.tableForm.orderStartTimeStart=this.getDateStr(-30) + " 00:00:00";
      this.tableForm.orderStartTimeEnd=this.getDateStr(0) + " 23:59:59";
    },
    // type: 0 查询手机号明文  1.查询买家账号明文
    showInfo(type, row, index) {
      var param = {
        bid: row.bid,
        detatilType: type,
      };

      blackDetail(param).then((res) => {
        if (res.code == "1") {
          if (type == "1") {
            // 买家账号
            this.tableData[index].pin = res.data.pin;
            this.tableData[index].pinState = true;
          } else if (type == "0") {
            // 手机号
            this.tableData[index].mobile = res.data.mobile;
            this.tableData[index].mobileState = true;
          }
        }
      });
    },

    //查询将接口数据显示出来
    queryList() {
      this.loading = true;
      if (this.opentime==true) {
        this.formDataList.startTime = this.getDateStr(-30) + " 00:00:00";
        this.formDataList.endTime = this.getDateStr(0) + " 23:59:59";
        this.opentime=false;
      }
      console.log(this.formDataList,111111111111111);
      listBlack(this.formDataList)
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.records;
          this.totalNum = res.data.total;
        })
        .catch((res) => {});
    },
    //查询条件数据查询
    searchFormOne() {
      this.formDataList.current = 1;
      this.formDataList.pin = this.tableForm.pin;
      this.formDataList.mobile = this.tableForm.mobile;
      this.formDataList.remark = this.tableForm.remark;
      // this.formDataList.crtimeStart = this.tableForm.orderStartTimeStart;
      // this.formDataList.crtimeEnd = this.tableForm.orderStartTimeEnd;
      this.formDataList.startTime = this.tableForm.orderStartTimeStart;
      this.formDataList.endTime = this.tableForm.orderStartTimeEnd;
      // console.log(this.tableForm);
      this.queryList();
    },
    //删除事件
    open1(bid) {
      this.bidid = bid;
      this.outerVisible = true;
    },
    //关闭删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    //确认删除
    handleDeleteTable() {
      this.outerVisible = false;
      this.open(this.bidid);
    },
    open(bid) {
      // this.$confirm("确定要删除吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      delSmsBlackList({ ids: bid })
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("删除成功");
            this.queryList();
          }
          // });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //批量删除弹框
    batchopen1() {
      let idsArr = [];
      this.multipleSelection.forEach((item) => {
        idsArr.push(item.bid);
      });
      console.log(idsArr.length);
      if (idsArr.length == null || idsArr.length == 0) {
        this.$message.warning("请选择数据");
        return;
      } else if (idsArr.length != null) {
        this.outerVisible1 = true;
      }
    },
    //关闭删除弹框
    closehandleDelete1() {
      this.outerVisible1 = false;
      this.$message.warning("已关闭删除");
    },
    //确认删除
    handleDeleteTable1() {
      this.outerVisible1 = false;
      this.batchopen();
    },
    //批量删除事件
    batchopen() {
      // this.$confirm("确定要删除吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      let idsArr = [];

      this.multipleSelection.forEach((item) => {
        idsArr.push(item.bid);
      });
      // if (idsArr.length != 0) {
      delSmsBlackList({ ids: idsArr.join(",") })
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success("删除成功");
            this.queryList();
          }
          // });
          // } else {
          //   this.$message.error("请选择数据");
          // }
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    delSmsBlackListBySelectCilck1() {
      this.outerVisible2 = true;
    },
    //关闭删除弹框
    closehandleDelete2() {
      this.outerVisible2 = false;
      this.$message.warning("已关闭删除");
    },
    //按查询结果删除删除
    handleDeleteTable2() {
      this.outerVisible2 = false;
      this.delSmsBlackListBySelectCilck();
    },

    //按查询结果删除
    delSmsBlackListBySelectCilck() {
      // this.$confirm("确定要删除吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      delSmsBlackListBySelect(this.tableForm)
        .then((res) => {
          // console.log(res);
          this.loading = false;
          // this.tableData = res.data.records;
          // this.totalNum = res.data.total;
          this.$message.success("删除成功!");
          this.queryList();
          // });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    // 排序
    changeTableSort(ev) {
      /*
       * sortPosition  排序方向 0:降序 1:升序 ,
       * sortType (string, optional): 排序类型 0:交易总额 1:交易次数 2:未购买天数 3:最后购买时间 ,
       */
      // console.log("en===", ev);

      if (ev.order === "descending") {
        this.formDataList.sortPosition = "0";
      } else if (ev.order === "ascending") {
        this.formDataList.sortPosition = "1";
      } else {
        this.formDataList.sortPosition = "";
      }

      if (ev.prop === "buyTotalMoney") {
        this.formDataList.sortType = "0";
      } else if (ev.prop === "buyTotalCount") {
        this.formDataList.sortType = "1";
      } else if (ev.prop === "notBuyTime") {
        this.formDataList.sortType = "2";
      } else if (ev.prop === "buyerLastTime") {
        this.formDataList.sortType = "3";
      }
      this.getData();
    },

    // 监听表格多选事件
    handleSelectionChange(val) {
      // console.log(val);
      this.multipleSelection = val;
    },

    //时间清空
    clearTimeSendTime() {
      // this.resetForm();
    this.tableForm = {
        orderStartTimeStart: "",
        orderStartTimeEnd: "",
      };
    },

    textarea() {},
    sortRecord() {},

    //关闭添加黑名单
    closeinsertBlackClick() {
      this.addBlackList = false;
      this.$message.warning("已取消添加黑名单");
    },

    //添加黑名单
    insertBlackClick() {
      if (this.form.insertmobile == "" && this.form.insertpin == "") {
        this.form.type = null;
      } else if (this.form.insertpin == "") {
        this.form.type = 0;
      } else if (this.form.insertmobile == "") {
        this.form.type = 1;
      }

      let add = {
        pins: this.form.insertpin.split(","),
        mobiles: this.form.insertmobile.split(","),
        remark: this.form.insertremark,
        type: this.form.type,
      };
      insertBlack(add)
        .then((res) => {
          if (res.data.sucessNum != 0) {
            this.queryList();
            this.form.insertmobile = "";
            this.form.insertpin = "";
            this.form.insertremark = "";
            let meg = `添加成功${res.data.sucessNum}个，添加失败${res.data.fialNum}个`;
            this.$message.success(meg);
          } else {
            this.$message.error("添加失败");
          }
        })
        .catch(() => {
          this.$message.error("添加失败");
        });
    },

    //重置事件
    resetForm() {
      this.tableForm = {
        pin: "",
        mobile: "",
        remark: "",
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 23:59:59",
      };
      this.formDataList = {
        size: 10,
        current: 1,
        orderStartTimeStart: this.getDateStr(-30) + " 00:00:00",
        orderStartTimeEnd: this.getDateStr(0) + " 23:59:59",
      };
      this.queryList();
    },

    //分页事件
    handleSizeChange(val) {
      this.formDataList.current = 1;
      this.formDataList.size = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.formDataList.current = val;
      this.queryList();
    },

    downloadTemplate() {
      let url = "",
        fileName = "";
      if (this.mobileType === "0") {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/BlackExample.xls";
        fileName = "黑名单导入手机号模板.xlsx";
      }
      if (this.mobileType === "1") {
        url =
          "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/BlackExampleForBuyerName.xls";
        fileName = "黑名单导入旺旺号模板.xlsx";
      }
      // let start = url.lastIndexOf(".");
      // let type = url.substring(start);
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },

    //导入数据
    handlClear() {
      // console.log('2342342')
      if (!this.venderType) {
        this.mobileType = "0";
      } else {
        this.mobileType = "1";
      }

      this.isupload = false;
      this.process = 0;
      this.proTimer = null;
      this.success = "";
      this.fileList = [];
      this.remark = "";
    },
    //限制当前文件个数
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择1个文件`);
    },
    uploadError(file, fileList) {
      this.process = 100;
      this.success = false;
      this.fileList = [];
    },

    //  点击上传功能,上传之前的大小校验
    // */
    beforeUpload(file) {
      let that = this;
      this.isupload = false;
      this.$nextTick(() => {
        that.process = 0;
        that.success = "";
        that.isupload = true;
        that.proTimer = setInterval(() => {
          if (that.process < 100) {
            that.process++;
          } else {
            clearInterval(that.proTimer);
          }
        }, 20);
      });
      // 这里是获取文件的id号
      this.uid = file.uid;
      this.files = file;
      // const extension = file.name.split(".")[1] === "xls";
      // const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 50;
      // if (!extension && !extension2) {
      //   this.$message.warning("上传模板只能是 xls、xlsx格式!");
      //   this.process = 100;
      //   this.success = false;
      //   //this.fileList = [];
      //   return;
      // }
      if (!isLt2M) {
        this.process = 100;
        this.success = false;
        this.$message.warning("上传模板大小不能超过 50MB!");
        return;
      }
      this.fileName = file.name;
      // return false; // 返回false不会自动上传
    },

    // /**
    //  * 上传文件成功
    //  */
    // upLoadSuccess(file, fileList) {
    //   // console.log(this.fileList);
    //   // console.log("upLoadSuccess==", file, fileList);
    //   if (file.code == "200") {
    //     this.process = 100;
    //     this.success = true;
    //     this.fileId = file.data;
    //     this.$message.success("上传成功!!!");
    //     // this.fileList = []
    //   } else {
    //     this.process = 100;
    //     this.success = false;
    //     this.$message.error(file.message);
    //     this.fileList = [];
    //   }
    //   // console.log(fileList);
    // },

    uploadError(file, fileList) {
      this.process = 100;
      this.success = false;
      this.fileList = [];
      // console.log(file)
      // console.log(fileList)
    },
    //导入黑名单取消按钮
    closeimportBlacklist() {
      this.dialogVisible = false;
      this.$message.warning("已取消黑名单导入");
    },
    //导入黑名单接口
    importBlacklist() {
      this.dialogVisible = false;
      if (this.files == null) {
        this.$message.warning("您未导入数据");
        return;
      }
      let mobileType = this.mobileType;
      let file = this.files;
      let remind = this.remark;
      console.log(this.files, "file");

      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", mobileType);
      formData.append("remind", remind);
      console.log("formData", formData);

      importBlack(formData)
        .then((res) => {
          console.log(res);
          if (res.code == "1") {
            // this.process = 100;
            // this.success = true;
            // this.fileId = res.data;
            this.$message.success("上传成功!!!");
            // this.fileList = []
          } else {
            // this.process = 100;
            // this.success = false;
            this.$message.error(res.message);
            // this.fileList = [];
          }
          // console.log(fileList);
        })
        .catch();
    },

    //导出
    exportData() {
      let arr = [];

      this.multipleSelection.forEach((item) => {
        arr.push(item.bid);
      });
      let bids = "";
      bids = arr.toString();
      let arrA = { bids };
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要导出的数据");
        return;
      } else {
        // exportBlack(arrA)
        // .then((res) => {
        //   if (res.status === 200) {
        // console.log(arrA);
        let elem = document.createElement("a");
        elem.style.display = "none";
        // let a = stringify(arrA);

        let url = `/jd-yusms/smsBlackList/export?bids=${arrA.bids}`;
        elem.href = url;
        console.log(url);
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);

        this.$message.success("导出成功");
        // }
        // })
        // .catch(() => {
        //   this.$message.error("导出失败");
        // });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item_select_text {
  float: left;
  margin-right: 10px;
  width: 410px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  color: #c0c4cc;
  padding-left: 15px;
  border-radius: 5px;
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #fe4d45;
    color: #ffffff;
    border-radius: 3px;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.show-box {
  position: relative;
  .hover-show {
    display: none;
    position: absolute;
    left: 0%;
    top: 50%;
    text-align: center;
    transform: translate(0, -50%);
    color: #fff;
    cursor: pointer;
    padding: 1px 10px;
    border-radius: 4px;
  }
  &:hover {
    .hover-show {
      display: inline-block;
    }
  }
}

/deep/.table-message {
  color: #fe4d45;
}

// /deep/.my_select_time .el-input__inner {
//   padding: 0px 8px !important;
// }
.b1 {
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.b2 {
  width: 98px;
  height: 32px;
  color: #ffffff;
  border: 1px solid #fe4d45;
  border-radius: 3px;
  background-color: #fe4d45;
  &:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }
  &:active {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.el-input,
.el-select {
  width: 280px;
}
.range-num {
  .el-input {
    width: 125px;
  }
  .to {
    padding: 0 8px;
  }
}
.select-input-type {
  .el-select {
    width: 136px;
    margin-right: 8px;
  }
  .el-input {
    width: 136px;
  }
}
.btn_group {
  text-align: center;
}

.section-right-content-box {
  padding: 0px 0px;
  .publicStyle {
    background-color: #fff;
    box-sizing: border-box;
    padding: 16px 16px 28px 30px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .float-right-button {
    float: right;
    .icon_wrap {
      cursor: pointer;
      display: inline-block;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 6px;
      width: 26px;
      height: 26px;
      box-sizing: border-box;
      font-size: 14px;
      margin-left: 10px;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }

  .integralChange {
    // margin-top: 10px;
    .jifRecords {
      width: 80px;
      height: 22px;
      font-size: 16px;
      // font-family: PingFang SC;
      font-weight: bold;
      line-height: 22px;
      color: rgba(46, 52, 88, 1);
      opacity: 1;
    }
    .item {
      margin-bottom: 15px;
      display: inline-block;
      vertical-align: middle;
      color: #666;
      font-size: 14px;
      margin-right: 42px;
      .item-name {
        font-size: 14px;
        margin-right: 8px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        display: inline-block;
      }
      .long-input {
        width: 280px;
        height: 32px;
        margin-right: 85px;
        display: inline-block;
      }
      .button_item {
        width: 100%;
        position:absolute .button_name {
          font-size: 14px;
          // font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          opacity: 1;
        }
      }
    }
  }
  .bottombase {
    margin-top: 20px;
  }
  .lineTwo {
    height: 1px;
    background: rgba(246, 246, 246, 1);
    opacity: 1;
    padding: 0px !important;
    margin-top: 16px;
    margin-bottom: 20px;
  }
  .share_button1 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
  }
  .share_button1:hover {
    color: #fff;
    background-color: #fe4d45;
  }
  .share_button2 {
    width: 98px;
    height: 32px;
    font-size: 14px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
  }
  .share_button2:hover {
    color: #fe4d45;
    background-color: #fff4f4;
    border: 1px solid #fe4d45;
  }
  .share_button3 {
    width: 98px;
    font-size: 14px;
    height: 32px;
    color: #ffffff;
    border-radius: 3px;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
  }
  .share_button3:hover {
    color: #fff;
    opacity: 0.9;
    background-color: #fe4d45;
  }
  .float-right-button {
    float: right;
    margin-bottom: 20px;
    .icon_wrap {
      cursor: pointer;
      display: inline-block;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 6px;
      width: 26px;
      height: 26px;
      box-sizing: border-box;
      font-size: 14px;
      margin-left: 10px;
      img {
        width: 14px;
        height: 14px;
      }
    }
  }
}
</style>